import { showSuccess, showError } from '@/utils/toastHelpers';
import { useCreatePost, useUpdatePost, useDeletePost } from '@/hooks/usePosts';
import { useEntityActions } from '@/hooks/useEntityActions';
import { Post, PostFormData } from './postsmanager.props';

const emptyForm: PostFormData = { title: '', excerpt: '', content: '', image: '' };

export const usePostsActions = () => {
  const createPost = useCreatePost();
  const updatePost = useUpdatePost();
  const deletePost = useDeletePost();

  const crud = useEntityActions<Post, PostFormData>({
    emptyForm,
    deleteMutation: deletePost,
    entityName: 'Постот',
  });

  const handleEdit = (post: Post) => {
    crud.openEdit(post, (p) => ({
      title: p.title, excerpt: p.excerpt, content: p.content, image: p.image,
    }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      if (crud.editingEntity) {
        await updatePost.mutateAsync({ id: crud.editingEntity.id, data: crud.formData });
        showSuccess('Успешно ажурирано', 'Постот е успешно ажуриран.');
      } else {
        await createPost.mutateAsync(crud.formData);
        showSuccess('Успешно креирано', 'Нов пост е успешно креиран.');
      }
      crud.resetDialog();
    } catch (error) {
      showError(error, 'постот');
    }
  };

  return {
    isDialogOpen: crud.isDialogOpen, setIsDialogOpen: crud.setIsDialogOpen,
    editingPost: crud.editingEntity, setEditingPost: crud.setEditingEntity,
    deleteTarget: crud.deleteTarget, setDeleteTarget: crud.setDeleteTarget,
    formData: crud.formData, setFormData: crud.setFormData,
    handleEdit, handleDelete: crud.handleDelete, confirmDelete: crud.confirmDelete, handleSubmit,
  };
};
